import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openCreateAppointmentAction = asyncModalAdapter({
	openModalName: 'CreateAppointmentAction',
	upModalName: 'CreateAppointmentAction',
	featureFlag: 'REACT_CREATE_APPOINTMENT_ACTION',
	rejectOnEmpty: true
});
